module.exports = __webpack_public_path__ + "img/Xaviaer.6bb4da98.jpg";